import { z } from "zod";

/**
 * Admin authentication payloads (SPEC §58).
 *
 * The CMS ships a single admin credential — no usernames. Under Cloudflare
 * Access the identity comes from the edge JWT and none of this is used; in the
 * development-auth deployment the shared credential is CMS-managed and can be
 * rotated from the Dashboard.
 */

/** `POST /api/auth/login` — prove knowledge of the credential. */
export const loginSchema = z.object({
  password: z.string().min(1).max(200),
});

export type LoginInput = z.infer<typeof loginSchema>;

/**
 * `POST /api/auth/password` — rotate the credential.
 *
 * The caller must already be authenticated with the current one; requiring it
 * again here keeps an abandoned browser tab from rotating a password it cannot
 * name.
 */
export const passwordChangeSchema = z
  .object({
    currentPassword: z.string().min(1).max(200),
    newPassword: z.string().min(8, "New password must be at least 8 characters").max(200),
  })
  .refine((input) => input.currentPassword !== input.newPassword, {
    message: "The new password must differ from the current one",
    path: ["newPassword"],
  });

export type PasswordChangeInput = z.infer<typeof passwordChangeSchema>;
